export default "__VITE_ASSET__C6Y4k4BU__"